import React from 'react';
import FairPracticeCode from '../components/fair-practice-code';

const FairPracticeCodePage = () => {
  return (
    <div>
      <FairPracticeCode />
    </div>
  );
};

export default FairPracticeCodePage;
